import React from 'react'
import { Link } from 'react-router-dom';

const BootCamp = () => {
  return (
    <div className='bootcamp-container'>
      <section>
        <h2>Decode Life: A Computational Biology Bootcamp for Future Scientists
          2025 Edition</h2>
        <p>
          Are you a high school student passionate about biology, math, and AI? Do you want to explore how machine learning, statistics, and coding are revolutionizing the field of genetics and the practice of medicine?
        </p>
        <p>
          Dream College Path is proud to present a 4-Week Computational Biology Summer Program called Decode Life: A Computational Biology BootCamp by Dr. Achinth Kumar
        </p>
        <div className='counseling'>
          <h4>
            Learn How to
          </h4>
          <ul>
            <li>
              <strong>Use AI to Explore Biology:</strong> Work with Large Language Models (LLMs) to analyze research papers, generate hypotheses, and even code with you
            </li>
            <li><strong>Discover Patterns in Data:</strong> Use Python to find trends in gene expression, disease markers, and more</li>
            <li><strong>Model Brains & Behavior:</strong> Simulate how neurons store memories and make decisions</li>
            <li><strong>Launch Your Own Research Project:</strong> Form teams, ask bold questions, analyze data, and present your discoveries like a real scientist</li>
          </ul>
        </div>
        <div>
          <h4>Program Description:</h4>
          <p><strong>An intensive and fast-paced bootcamp designed to teach you the fundamentals of computational biology, data science, and AI—quickly and effectively!</strong></p>
          <p> This introductory program blends biology, math, and machine learning with real-world applications in genetics, disease modeling, and drug discovery. Students will gain hands-on experience working with biological datasets, building simple AI models, and understanding the science behind cutting-edge breakthroughs in personalized medicine and biotech.
            The program wraps up with a collaborative group project and poster presentation, with feedback from instructors and professionals in the field.</p>
          <p>Prerequisites assume high school-level biology and basic algebra—we’ll walk you through everything else along the way! Experience with Python is helpful but not required.</p>
        </div>
        <div>
          <h4>
            Time and Location
          </h4>
          <p>
            <span>Sat June 7 - Tue July 1 2025</span><br />
            <span>Every Sat & Sun 1-4 pm PST</span><br />
            <span>Office Hours: Tuesday-Thursday 5pm (online)</span><br />
            <span>Location: Bay Area/Hybrid (exact location soon)</span>
          </p>
        </div>
        <div>
          <h4>
            Format
          </h4>
          <p>
            2 sessions per week (Saturday & Sunday)<br />
            3-hour sessions (1.5 hours lecture, 1.5 hours project discussion)<br />
            Awards during the Final Project and Poster Presentation Competition
          </p>
        </div>
        <div>
          <h4>
            <Link className='bootcamp-button' to="/sign-up?page=bootcamp">Click here to Register/Enroll</Link>
          </h4>

        </div>
        <div>
          <h4>
            Instructor
          </h4>
          <div>
            <img src="/images/achint_kumar.png" alt="Achint Kumar" />
            <h5>Dr. Achint Kumar</h5>
          </div>
          <p>
            Achint Kumar is a scientist at UC San Diego School of Medicine and holds a Ph.D. in Computational Neuroscience from Duke University. He is the Founder and CEO of Hypatia-AI, a company focused on AI-informed diabetes care. He is also the best-selling author of Physics of Artificial Intelligence: Theory and Applications.
          </p>
        </div>
      </section>
      <section className='img_section'>
        <img src="/images/BootCampFlyerWeb.jpg" alt="BootCampFlyerWeb" />
      </section>

    </div>
  )
}

export default BootCamp;